export default {
  title: 'Tuo ruokalista',
  master_title: 'Brändi-tila - Tuo ruokalista',
  buttons: {
    import: 'Tuo',
  },
  toasts: {
    import: {
      pending:
        '⏳Koska tuonti voi joskus olla hidasta, teemme sen taustalla. Tarkista ravintolan ruokalista muutaman minuutin kuluttua.',
    },
  },
};
